import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { OfferSelector } from './OfferSelector';
export function PricingSection() {
  return <section className="py-12 md:py-24 bg-yoga-purple-900 text-white relative" id="comprar" data-id="element-259">
      <div className="absolute inset-0 bg-hero-pattern opacity-50" data-id="element-260"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-261">
        <div className="text-center mb-8 md:mb-12" data-id="element-262">
          <h2 className="text-2xl md:text-5xl font-serif font-bold mb-2 md:mb-4" data-id="element-263">
            PRECIOS Y OFERTAS
          </h2>
          <p className="text-base md:text-xl text-yoga-purple-200" data-id="element-264">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <OfferSelector variant="pricing" data-id="element-265" />
      </div>
    </section>;
}